import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import { api } from "@/lib/api";
import { Stars } from "@/components/site/Stars";

const FILTERS = [["pending", "In attesa"], ["approved", "Approvate"], ["rejected", "Rifiutate"]];

export default function AdminReviews() {
  const [status, setStatus] = useState("pending");
  const [list, setList] = useState([]);

  const load = () => api.get(`/admin/reviews?status=${status}`).then((r) => setList(r.data));
  useEffect(() => { load(); }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const act = async (r, s) => {
    await api.patch(`/admin/reviews/${r.id}`, { status: s });
    toast.success(s === "approved" ? "Recensione approvata" : "Recensione rifiutata");
    load();
  };

  return (
    <div data-testid="admin-reviews">
      <div className="flex gap-2 mb-6">
        {FILTERS.map(([v, l]) => (
          <button key={v} onClick={() => setStatus(v)} data-testid={`admin-reviews-filter-${v}`}
            className={`px-4 py-2 text-sm font-display italic uppercase font-bold border ${status === v ? "bg-red-600 border-red-600" : "border-zinc-800 text-zinc-400 hover:text-white"}`}>{l}</button>
        ))}
      </div>
      {list.length === 0 && <p className="text-zinc-500" data-testid="admin-reviews-empty">Nessuna recensione.</p>}
      <div className="space-y-3">
        {list.map((r) => (
          <div key={r.id} className="bg-[#18181C] border border-zinc-800 p-5 flex flex-col md:flex-row gap-4" data-testid={`admin-review-${r.id}`}>
            <div className="flex-1">
              <div className="flex items-center gap-3 flex-wrap">
                <span className="font-display italic uppercase font-bold">{r.name}</span>
                <Stars value={r.rating} />
                <span className="text-xs text-zinc-500">{r.product_name} · {r.order_code} · {new Date(r.created_at).toLocaleDateString("it-IT")}</span>
              </div>
              <p className="text-zinc-300 mt-2">{r.comment}</p>
            </div>
            <div className="flex gap-2 md:items-start">
              {r.status !== "approved" && <button className="btn-red !px-4 !py-2 text-xs" onClick={() => act(r, "approved")} data-testid={`admin-review-approve-${r.id}`}><Check size={14} /> Approva</button>}
              {r.status !== "rejected" && <button className="btn-ghost !px-4 !py-2 text-xs" onClick={() => act(r, "rejected")} data-testid={`admin-review-reject-${r.id}`}><X size={14} /> Rifiuta</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
